import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const partnerVaultsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/partner-vaults",
  component: lazyRouteComponent(() => import("./partner-vaults.page.js"), "PartnerVaultsPage"),
});
